// extracted by mini-css-extract-plugin
module.exports = {"header":"PageHeader_header__XAJWf","stat-row":"PageHeader_stat-row__CUt1_","info":"PageHeader_info__3Ic7I","only-btn":"PageHeader_only-btn__1P3_-"};